export default [
    {
        path: '/campaign',
        name: 'campaign',
        component: () => import('../views/Campaign.vue'),
        meta: {
            fixedContent: true,
            accountSelect: {
                disabled: false,
                showParentAccounts: false,
            },
            header: {
                account: true,
                notification: true,
                search: true,
                settings: true,
            },
            saveInUrl: ['accountId'],
        },
    },
];
